/**
 * BrandThemeProvider (TMMAPP-0035). Starts from this host's cached theme when one is stored (so
 * the loading and bootstrap-failure screens are already branded), else the built-in default —
 * never unstyled. `BootstrapGate` brings it up to date once the auth origin is known.
 */
import { useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { readCachedBrandTheme, type BrandTheme } from '@/theme/brandTheme';
import { PLATFORM_DEFAULT_THEME } from '@/theme/platformDefaultTheme';
import { BrandThemeContext, type BrandThemeContextValue } from './brand-theme-context';

function initialBrandTheme(): BrandTheme {
  return readCachedBrandTheme()?.theme ?? PLATFORM_DEFAULT_THEME;
}

export function BrandThemeProvider({ children }: { children: ReactNode }) {
  const [brandTheme, setBrandTheme] = useState<BrandTheme>(initialBrandTheme);
  const value = useMemo<BrandThemeContextValue>(
    () => ({ brandTheme, setBrandTheme }),
    [brandTheme],
  );
  return <BrandThemeContext.Provider value={value}>{children}</BrandThemeContext.Provider>;
}
